<ng-container *ngIf="classifications && classifications.length">
  <app-item-classification-pill
    *ngFor="let classification of classifications" [classification]="classification">
  </app-item-classification-pill>
</ng-container>